/**
 * Typography size, leading, and tracking classes for every TextD2C variant.
 * Import these constants wherever matching type-scale is needed outside the
 * TextD2C component itself (e.g., in other components, style utilities, etc.).
 */
export const textD2CSizes = {
  h1: "text-[40px] leading-[45px] md:text-[80px] md:leading-[90px]",
  h2: "text-[34px] leading-[36px] tracking-[1%] md:text-[56px] md:leading-[60px]",
  h3: "text-[30px] leading-[32px]",
  h4: "text-[18px] leading-[24px] tracking-[1%] md:text-[20px] md:leading-[26px]",
  h5: "text-[14px] leading-[18px] md:text-[16px] md:leading-[20px]",
  h6: "text-[12px] leading-[14px] tracking-[2%]",
  "p-xlarge": "text-[26px] leading-[32px] md:text-[38px] md:leading-[48px]",
  "p-large": "text-[16px] leading-[24px] md:text-[21px] md:leading-[30px]",
  p: "text-[14px] leading-[20px] md:text-[16px] md:leading-[23px]",
  "p-small": "text-[12px] leading-[16px] md:leading-[17px]",
  "p-xsmall": "text-[10px] leading-[13px]",
  pillar: "text-[10px] leading-none tracking-[4%]",
} as const;
